module.exports = __webpack_public_path__ + "assets/img/scenePic19.e3e8e99c.png";